import { Component, Inject, OnInit } from '@angular/core';
import { MeasurementType, MultipleMeasurementsVM, UpdateComponenMultipletMeasurementModel } from '../../models/interpretation.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { CustomeEvaluationRangeVM } from '../../../../modules/CustomEval/custom-eval.model';

@Component({
  selector: 'app-view-multiple-measurements',
  templateUrl: './view-multiple-measurements.component.html',
  styleUrls: ['./view-multiple-measurements.component.scss']
})
export class ViewMultipleMeasurementsComponent implements OnInit {
  MeasurementList:MultipleMeasurementsVM[];
  ComponentTypeId:number;
  EvalautionRange: CustomeEvaluationRangeVM;
  UOM: MeasurementType;
  toolId: number;
  isChange: boolean = false;
  constructor(public dialogRef: MatDialogRef<ViewMultipleMeasurementsComponent>,
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    @Inject(MAT_DIALOG_DATA) private _data: any) { }

  ngOnInit() {
    this.MeasurementList = this._data.MeasurementList;
    this.ComponentTypeId = this._data.ComponentTypeId;
    this.UOM = this._data.UOM;
    this.EvalautionRange = this._data.EvalRange;
    this.toolId = this._data.ToolId;
  }

  onNoClick(){
    this.dialogRef.close(this.isChange);
  }

  updateMeasurement(measurementVM: MultipleMeasurementsVM, event: any) {
    var measurement = event.target.value;
    //console.log("event____11111", event.target.value)
    const m = new UpdateComponenMultipletMeasurementModel(measurementVM.Id, measurementVM.InspectionId, measurementVM.InspectionDetailId, measurement, this.ComponentTypeId, this.UOM, this.EvalautionRange, this.toolId);
    this._interp.updateComponentMultipleMeasurement(m).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Updated', r.m_Item2);
        this.isChange = true;
      } else {
        this._notify.error('Failed', 'Unable to update component multiple measurement. ');
        console.error(r.m_Item2);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to update component multiple measurement. ');
      console.error(err);
    });
  }

}
